import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as hostingSettingsActions from '../actions/hosting-settings.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {HostingService} from "../../websites/website/hosting/hosting.service";
import {LoadHostingSettings} from "../actions";

@Injectable()
export class HostingSettingsEffects {

  loadHostingSettings = createEffect(() => this._actions$.pipe(
    ofType(hostingSettingsActions.LOAD_HOSTING_SETTINGS),
    mergeMap((action: LoadHostingSettings) => {
      return this._hostingService.hostingToolsSettings(action.payload)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new hostingSettingsActions.LoadHostingSettingsSuccess({
                websiteId: action.payload,
                entities: response.data
              });
            }
            return new hostingSettingsActions.LoadHostingSettingsFail(response.message);
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _hostingService: HostingService
  ) {
  }


}
